module.exports = __webpack_public_path__ + "media/img/features/one-click-option-8546b8997e9dac71b7b765d4e1092bce.png";